import styled from "styled-components";

export const Container = styled.div`
  justify-content: ${(props) => props?.justifyContent ?? "inherit"};
  display: ${(props) => props?.display ?? "inherit"};
  align-items: ${(props) => props?.alignItems ?? "inherit"};
  flex-direction: ${(props) => props?.flexDirection ?? "initial"};
  //background-color: white;
  //position: relative;
  background: ${(props) =>
    `url(${props.backgroundImage}),url(${props.backgroundImage2}),url(${props.backgroundImage3})`};
  background-repeat: no-repeat;
  background-position: ${(props) => props?.backgroundPosition ?? "0 12vh"};
  background-size: cover;
  margin: ${(props) => props?.margin ?? "inherit"};
  max-width: ${(props) => props?.maxWidth ?? "unset"};
`;

export const ImgBanner = styled.img`
  @media only screen and (max-width: 769px) {
    display: flex;
    width: 100%;
  }
  width: 100vw;
  margin-top: -5px;
`;

export const Headline = styled.h2`
  text-align: center;
  position: absolute;
  bottom: 0%;
  left: 50%;
  transform: translate(-50%, -60%);
  font-size: 18px;
  line-height: 24px;
  margin: 0;
`;

export const HintScroll = styled.h2`
  font-size: 14px;
  color: white;
  text-align: center;
  left: 50%;
  //position: absolute;
  bottom: 0%;
  // transform: translate(-50%, 60%);
  cursor: pointer;
  margin-bottom: -0.8rem;
  line-height: 2.8rem;
  max-width: 450px;
`;

export const ScrollDownIcon = styled.img`
  @keyframes updown {
    0% {
      transform: translateY(-8%);
    }

    50% {
      transform: translateY(8%);
    }

    100% {
      transform: translateY(-8%);
    }
  }
  src: ${({ src }) => src ?? null};
  animation: updown 1.2s ease infinite;
  //position: absolute;
  top: 5px;
  //top: 0;
  bottom: 0%;
  left: 46%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  tint-color: white;
  max-width: 450px;
`;

export const BannerWrapper = styled.div`
  background: ${(props) =>
    props.backgroundImage
      ? `url(${props.backgroundImage})`
      : props?.backgroundColor ?? "transparent"};
  height: ${(props) => props?.height ?? "100vh"};
  min-height: ${(props) => props?.minHeight ?? "auto"};
  padding-top: ${(props) => props?.paddingTop ?? "0"};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;

  z-index: ${(props) => props?.zIndex ?? 0};
  position: ${(props) => props?.position ?? "inherit"};
  border: ${(props) => props?.border ?? "none"};
  border-bottom-left-radius: ${(props) =>
    props.borderBottomLeftRadius ?? "0px"};
  border-bottom-right-radius: ${(props) =>
    props.borderBottomRightRadius ?? "0px"};
  justify-content: ${(props) => props?.justifyContent ?? "unset"};
`;

export const TitleImg = styled.img`
  max-width: ${(props) => props?.maxWidth ?? "auto"};
  margin-top: ${(props) => props?.marginTop ?? "40px"};
  position: ${(props) => props?.position ?? "relative"};
  z-index: 2;
  transform: ${(props) => props?.scale ?? "none"};
  height: ${(props) => props?.height ?? "auto"};
`;

export const PialaByuImg = styled.img`
  margin: ${(props) => props?.margin ?? 0};
  z-index: 2;
  // width: 155.551px;
  // height: 138.825px;
  display: flex;
  max-height: ${(props) => props?.maxHeight ?? "398px"};
  transform: ${(props) => props?.scale ?? "none"};
`;

export const ContactPerson = styled.img`
  width: 175.976px;
`;

export const ContentBottom = styled.div`
  // margin-top: auto;
  margin-bottom: ${(props) => props?.marginBottom ?? 0};
`;

export const Box = styled.div`
  justify-content: center;
  display: flex;
  border-radius: 16px;
  background: linear-gradient(
    90deg,
    rgba(4, 195, 243, 0.56) 0%,
    rgba(28, 117, 188, 0.86) 49.95%,
    rgba(39, 43, 100, 0.81) 100%
  );
  text-align: center;
  white-space: pre;
  padding: 16px;
  border: 2px solid #fff;
  // background-blend-mode: multiply, normal;
  // box-shadow: 0px 8px 20px 0px rgba(3, 151, 193, 0.3),
  //   -4px -4px 17px 0px rgba(130, 227, 255, 0.5) inset;
  // backdrop-filter: blur(4.5px);
`;

export const RibbonImg = styled.img`
  position: absolute;
  top: 18vh;
`;
